import Chip from '@mui/material/Chip';
import { useState, useEffect, useRef } from 'react';

const ResponsiveChips = ({ items = [], minDisplay = 1, maxDisplay = 10, field = '', chipVariant = '' }) => {
  const containerRef = useRef(null);
  const [visibleChips, setVisibleChips] = useState([]);
  const [hiddenCount, setHiddenCount] = useState(0);

  useEffect(() => {
    if (!items.length || !containerRef.current) return;

    const resizeObserver = new ResizeObserver(() => updateVisibleChips());
    resizeObserver.observe(containerRef.current);

    updateVisibleChips(); // Initial calculation

    return () => resizeObserver.disconnect();
  }, [items]);

  const updateVisibleChips = () => {
    if (!containerRef.current) return;

    const containerWidth = containerRef.current.offsetWidth;
    let totalWidth = 0;
    let chipsToShow = [];
    let remainingChips = items.length;
    const minChips = Math.min(minDisplay, items.length);

    const tempDiv = document.createElement('div');
    tempDiv.style.position = 'absolute';
    tempDiv.style.visibility = 'hidden';
    tempDiv.style.whiteSpace = 'nowrap';
    document.body.appendChild(tempDiv);

    for (let i = 0; i < items.length; i++) {
      tempDiv.innerHTML = `<span class="px-2 py-1 border rounded">${items[i][field]}</span>`;
      const chipWidth = tempDiv.offsetWidth;

      if (
        (totalWidth + chipWidth > containerWidth && chipsToShow.length >= minChips) ||
        chipsToShow.length >= maxDisplay
      ) {
        break;
      }

      totalWidth += chipWidth;
      chipsToShow.push(items[i]);
      remainingChips--;
    }

    document.body.removeChild(tempDiv);
    setVisibleChips(chipsToShow);
    setHiddenCount(remainingChips);
  };

  return (
    <div
      ref={containerRef}
      className='flex flex-wrap items-center gap-2 overflow-hidden'
      style={{ maxWidth: '100%' }}
    >
      {visibleChips.map((item) => (
        <Chip key={`class-${item?._id}`} size='small' label={item[field]} variant={chipVariant ?? ''} />
      ))}
      {hiddenCount > 0 && (
        <Chip
          size='small'
          label={`+${hiddenCount}`}
          style={{ backgroundColor: '#32668b', color: '#fff', fontWeight: 'bold' }}
        />
      )}
    </div>
  );
};

export default ResponsiveChips;
